/* 左边的品牌列表 */
import React, { useRef, useState, useEffect } from 'react'
import get from 'lodash/get'
import classnames from 'classnames'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image } from 'Components/view-image'
import { ContextStore } from './reducer'

import { IConditionsProps, IInfoProps, ISortProps } from './interface'
import Link from 'next/link'

import SingleList from './single-list'

const typeConfig = [
  {
    text: '轿车',
    key: 'series_type',
    param: 0,
    children: [
      {
        param: 'all',
        text: '全部',
        key: 'series_type',
      },
      {
        param: '0',
        text: '微型车',
        key: 'outter_detail_type',
      },
      {
        param: '1',
        text: '小型车',
        key: 'outter_detail_type',
      },
      {
        param: '2',
        text: '紧凑型车',
        key: 'outter_detail_type',
      },
      {
        param: '3',
        text: '中型车',
        key: 'outter_detail_type',
      },
      {
        param: '4',
        text: '中大型车',
        key: 'outter_detail_type',
      },
      {
        param: '5',
        text: '大型车',
        key: 'outter_detail_type',
      },
    ],
  },
  {
    text: 'SUV',
    key: 'series_type',
    param: 1,
    children: [
      {
        param: 'all',
        text: '全部',
        key: 'series_type',
      },
      {
        param: '10',
        text: '小型SUV',
        key: 'outter_detail_type',
      },
      {
        param: '11',
        text: '紧凑型SUV',
        key: 'outter_detail_type',
      },
      {
        param: '12',
        text: '中型SUV',
        key: 'outter_detail_type',
      },
      {
        param: '13',
        text: '中大型SUV',
        key: 'outter_detail_type',
      },
      {
        param: '14',
        text: '大型SUV',
        key: 'outter_detail_type',
      },
    ],
  },
  {
    text: 'MPV',
    key: 'series_type',
    param: 2,
    children: [
      {
        param: 'all',
        text: '全部',
        key: 'series_type',
      },
      {
        param: '20',
        text: '小型MPV',
        key: 'outter_detail_type',
      },
      {
        param: '21',
        text: '紧凑型MPV',
        key: 'outter_detail_type',
      },
      {
        param: '22',
        text: '中型MPV',
        key: 'outter_detail_type',
      },
      {
        param: '23',
        text: '大型MPV',
        key: 'outter_detail_type',
      },
    ],
  },
  {
    text: '跑车',
    key: 'series_type',
    param: 4,
  },
  {
    text: '微面',
    key: 'series_type',
    param: 7,
  },
  {
    text: '轻客',
    key: 'series_type',
    param: 6,
  },
  {
    text: '卡车',
    key: 'series_type',
    param: '13,8,3',
    classParam: '9',
    children: [
      {
        param: '13,8,3',
        text: '全部',
        key: 'series_type',
      },
      {
        param: '13',
        text: '轻卡',
        key: 'series_type',
      },
      {
        param: '8',
        text: '微卡',
        key: 'series_type',
      },
      {
        param: '3',
        text: '皮卡',
        key: 'series_type',
      },
    ],
  },
]

interface IProps {
  handleOptionClick: (
    item: ISortProps,
    line: number,
    clearLine?: number
  ) => void
  isOptionActive: (option: ISortProps, line: number) => boolean
}

const series_line = 1
const outter_line = 12

export default function SeriesType({
  handleOptionClick,
  isOptionActive,
}: IProps) {
  const { state, dispatch } = React.useContext(ContextStore)
  const [currentLetter, setCurrentLetter] = useState('')
  const [currentId, setCurrentId] = useState(-1)

  function getType() {
    if (state.series_type) {
      return 'series_type'
    }

    if (state.outter_detail_type) {
      return 'outter_detail_type'
    }

    return ''
  }

  // 对应 series_type 还是 outter_detail_type
  function isSeriesTypeActive(item: any) {
    if (!state.series_type && !state.outter_detail_type) {
      return false
    }
    if (state.series_type) {
      return state.series_type.find((option: any) => {
        if (item?.param?.toString()?.indexOf(',') > -1) {
          return (
            item.param
              .toString()
              ?.split(',')
              ?.indexOf(option?.param?.toString()) > -1 ||
            option?.param?.toString() === item.param.toString()
          )
        }
        return option?.param?.toString() === item.param.toString()
      })
    }

    if (state.outter_detail_type && item.children) {
      return state.outter_detail_type.find((option: any) =>
        item.children.find(
          (child: any) =>
            option?.param?.toString() === child.param.toString() &&
            child.key === 'outter_detail_type'
        )
      )
    }
  }

  function outterDetailValue(item: any) {
    if (!state.series_type && !state.outter_detail_type) {
      return ''
    }
    if (state.series_type && isSeriesTypeActive(item)) {
      if (item?.param?.toString()?.indexOf(',') > -1) {
        return state?.series_type?.[0]?.param
      }
      return 'all'
    }

    if (state.outter_detail_type) {
      return state.outter_detail_type[0]['param']
    }
  }

  function renderLetters() {
    return (
      <div className="tw-flex">
        <div
          key={'x'}
          className={classnames('item-child nolimit-mr nolimit-width', {
            active: !state.series_type && !state.outter_detail_type,
          })}
          onClick={() => {
            handleOptionClick(
              {
                param: 'x',
                text: '不限',
                key: state.series_type ? 'series_type' : 'outter_detail_type',
              },
              state.series_type ? series_line : outter_line
            )
          }}
        >
          不限
        </div>
        <ul className="car-wrap">
          {typeConfig.map((series_type: any) => (
            <li
              key={series_type.param}
              className={classnames(
                `item-child car-mr car-width car-child car-child-${series_type.param}`,
                {
                  active: isSeriesTypeActive(series_type),
                  hasChildren: series_type?.children?.length,
                }
              )}
              onClick={(e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
                e.preventDefault()
                e.stopPropagation()
                sendTeaCommEvent('click_brand_initial_index', {
                  initial: 'letter',
                })
                handleOptionClick(
                  {
                    param: series_type.param,
                    text: series_type.text,
                    key: series_type.key,
                  },
                  series_line,
                  outter_line
                )
              }}
            >
              <span
                className={`car-type car-img-${
                  series_type.classParam || series_type.param
                }`}
              />
              <span className="car-name">{series_type.text}</span>
              {series_type?.children?.length && (
                <div className="car-children">
                  <SingleList
                    options={series_type?.children}
                    onChange={(item) => {
                      if (
                        item &&
                        (item.param !== 'all' || item.param.indexOf(',') > -1)
                      ) {
                        handleOptionClick(
                          {
                            param: item.param,
                            text: item.text,
                            key: item.key,
                          },
                          item.key === 'series_type'
                            ? series_line
                            : outter_line,
                          item.key === 'series_type' ? outter_line : series_line
                        )
                        return
                      }
                      handleOptionClick(
                        {
                          param: series_type.param,
                          text: series_type.text,
                          key: series_type.key,
                        },
                        item.key === 'series_type' ? series_line : outter_line,
                        item.key === 'series_type' ? outter_line : series_line
                      )
                    }}
                    type={getType()}
                    value={outterDetailValue(series_type)}
                  />
                </div>
              )}
            </li>
          ))}
        </ul>
        <style jsx>
          {`
            .nolimit-mr {
              margin-right: 30px !important;
            }
            .nolimit-width {
              height: 30px;
            }
            .car-wrap {
              flex: 1;
            }
            .car-width {
              width: 98px;
            }
            .car-width.hasChildren {
              width: 110px;
            }
            .car-mr {
              margin-right: 30px !important;
            }
            li {
              position: relative;
            }
            .after.active:after {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              bottom: -15px;
              left: 50%;
              transform: translate(-50%, 0);
              border-right: 7px solid transparent;
              border-left: 7px solid transparent;
              border-bottom: 9px solid #f7f8fc;
            }
            .car-type {
              display: inline-block;
              width: 51px;
              height: 24px;
              vertical-align: middle;
              margin-right: 2px;
              margin-top: -6px;
            }
            .active .car-img-0 {
              background: url(${require('./static/0-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-0 {
              background: url(${require('./static/0-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-1 {
              background: url(${require('./static/1-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-1 {
              background: url(${require('./static/1-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-2 {
              background: url(${require('./static/2-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-2 {
              background: url(${require('./static/2-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-4 {
              background: url(${require('./static/4-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-4 {
              background: url(${require('./static/4-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-6 {
              background: url(${require('./static/6-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-6 {
              background: url(${require('./static/6-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-7 {
              background: url(${require('./static/7-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-7 {
              background: url(${require('./static/7-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-9 {
              background: url(${require('./static/9-bg.png')}) no-repeat 0 0 /
                cover;
            }
            .active .car-img-9 {
              background: url(${require('./static/9-active.png')}) no-repeat 0 0 /
                cover;
            }
            .car-img-6,
            .car-img-7,
            .car-img-9 {
              margin-top: -2px !important;
            }
            .hasChildren {
              position: relative;
            }
            .hasChildren:hover:after {
              transform: rotate(180deg);
            }
            .hasChildren .car-child {
              padding-right: 12px;
            }
            .hasChildren:after {
              content: '';
              position: absolute;
              width: 0;
              height: 0;
              top: 13px;
              right: 6px;
              border-right: 4px solid transparent;
              border-left: 4px solid transparent;
              border-top: 5px solid #1f2129;
              transition: all 0.1s ease-in-out;
            }
            .car-children {
              position: absolute;
              background: #f7f8fc;
              left: 0;
              top: 31px;
              display: none;
              z-index: 99;
            }
            .car-children:hover {
              display: block;
            }
            .hasChildren .car-name {
              padding-right: 8px;
            }
            .car-child.active {
              background: #fff !important;
            }
            .car-child:hover {
              background: rgba(255, 225, 0, 0.2);
            }
            .hasChildren:hover .car-children {
              display: block;
            }
          `}
        </style>
      </div>
    )
  }

  return (
    <div className="item-wrap">
      <p className="name">级别</p>
      <div className="item-list">{renderLetters()}</div>
    </div>
  )
}
